var _path, _path2, _path3, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgActivemore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.454468C15.0258 0.454468 19.0996 4.52829 19.0996 9.55408C19.0996 14.5799 15.0258 18.6537 10 18.6537C4.97421 18.6537 0.900391 14.5799 0.900391 9.55408C0.900391 4.52829 4.97421 0.454468 10 0.454468Z",
    fill: "#006EC2",
    stroke: "#006EC2",
    strokeWidth: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.347L7.73162 7.70052C7.56425 7.50526 7.29289 7.50526 7.12553 7.70052C6.95816 7.89579 6.95816 8.21237 7.12553 8.40763L9.69695 11.4076C9.86432 11.6029 10.1357 11.6029 10.303 11.4076L12.8745 8.40763C13.0418 8.21237 13.0418 7.89579 12.8745 7.70052C12.7071 7.50526 12.4358 7.50526 12.2684 7.70052L10 10.347Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_9589",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 7,
    width: 6,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 10.347L7.73162 7.70052C7.56425 7.50526 7.29289 7.50526 7.12553 7.70052C6.95816 7.89579 6.95816 8.21237 7.12553 8.40763L9.69695 11.4076C9.86432 11.6029 10.1357 11.6029 10.303 11.4076L12.8745 8.40763C13.0418 8.21237 13.0418 7.89579 12.8745 7.70052C12.7071 7.50526 12.4358 7.50526 12.2684 7.70052L10 10.347Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_9589)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivemore);
export default __webpack_public_path__ + "static/media/activemore.1aa8c5745bb8c2b121ad0ad5427c33ad.svg";
export { ForwardRef as ReactComponent };